import { styled } from '@/stitches.config';

import { ReactComponent as SuccessIcon } from '@assets/icons/success.svg';
import { Box } from '@common/components';

export const StyledSuccessIcon = styled(SuccessIcon, {
  color: '$green300',
});

const commonStyles = {
  paddingTop: '$6',
  paddingBottom: '$6',
};

export const StyledNotes = styled(Box, commonStyles);

export const StyledConsentedChecks = styled(Box, {
  display: 'flex',
  gap: '$10',
  paddingBottom: '$2',
});

export const StyledConsentedCheck = styled(Box, { display: 'flex', gap: '$2' });
